export default {"src":"/_next/static/media/ArrowUpSVG.0a2fd5bd.svg","height":8,"width":12};